import React from "react";
import {
  Card,
  Typography,
  Space,
  Divider,
  Button,
  Row,
  Col,
  Tag,
} from "antd";
import moment from "moment";

const { Title, Text, Paragraph } = Typography;

const TicketChip = (props) => {
  const {
    ticketID,
    type,
    subtype,
    status,
    tenant,
    appartment,
    location,
    recuring,
    clickView,
    isPaidService,
    title,
    unit,
    data,
    ticketsCategory,
    itemStatus,
    setVisible,
    setTrigger,
    setParentTicketId,
  } = props;

  // parentTicketId

  const createFollowUpTicket = (ticketId) => {
    setParentTicketId(ticketId);
    setTrigger(0);
    setVisible(true);
  };

  const viewFollowUpParent = (item) => {
    let folloUpData = { ...item };
    folloUpData.followUp = true;
    clickView(folloUpData);
  };

  return (
    <Card
      className={`chip-wrap ticket-child-card ${
        ticketsCategory === "New" && "new-chip"
      } ${ticketsCategory === "In Progress" && "progress-chip"} ${
        ticketsCategory === "Closed" && "closed-chip"
      } ${ticketsCategory === "Scheduled" && "scheduled-chip"}`}
    >
      <Row style={{ minHeight: 8 }}> 
        <Col span={12} style={{ textAlign: "left" }}>
          {data?.ticketSource === "external" && (
            <Tag style={{ padding: "0 0.5rem", fontSize: "12px", lineHeight: "1.25rem" }} color="gray">
              External
            </Tag>
          )}
        </Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Text className="ag-primary fontWeight600 smallFont11">
            {data?.preferredDate && moment(data?.preferredDate).format("DD-MMM-YY")}{" "}
            {data?.preferredTimeStart && moment(data?.preferredTimeStart, "hh:mm:ss").format("LT")}
          </Text>
        </Col>
      </Row>
      <Title level={5} className="mb-0 ">
        {type} - <span className="ticket-subtitle">{title}</span>
      </Title>
      <Space size={4} className="mb-1">
        <Text className="ag-success fontWeight600">#{ticketID}</Text>
        {isPaidService && (
          <Title
            style={{ marginTop: "5px" }}
            level={5}
            className="ag-success fontWeight600"
          >
            {isPaidService && "(Paid)"}
          </Title>
        )}
        {recuring && (
          <>
            <Divider type="vertical" className="ticket-sep" />
            <Text className="ag-error fontWeight600">Recurring Issue</Text>
          </>
        )}
      </Space>
      <Row align="bottom">
        <Col flex="auto">
          <Paragraph className="ag-primary fontWeight600 mb-0">
            {unit}
          </Paragraph>
          <Paragraph className="ag-primary fontWeight600 mb-0">
            {tenant}
          </Paragraph>
          <Paragraph
            style={{ color: "#00576e", fontWeight: 500 }}
            className="smallFont12 text-italic mb-0"
          >
            {data?.unitNumber} - {appartment}
          </Paragraph>
          <Paragraph className="smallFont12 text-italic mb-0">
            {location}
          </Paragraph>
          <Paragraph className="smallFont12 ag-lightblue fontWeight600 mb-0">
            Status:{" "}
            <span style={{ textTransform: "capitalize" }}>{status}</span>
          </Paragraph>
          <Paragraph className="smallFont12 ag-lightblue fontWeight600 mb-0">
            Assigned: {data?.technician?.name && data?.technician?.name}
          </Paragraph>

          {data?.parentTicketId?.length > 0 && !data?.recurrence && (
            <Paragraph className="smallFont12 ag-lightblue fontWeight600 mb-0">
              <Button
                className="p-0 ag-success fontWeight600"
                type="link"
                onClick={() => viewFollowUpParent(data)}
              >
                Follow-Up Ticket
              </Button>
            </Paragraph>
          )}
        </Col>
      </Row>
      <Space size={4} className="mb-1">
        <Row>
          <Button
            className="p-0 ag-success fontWeight600"
            type="link"
            style={{ position: "absolute", right: 8, bottom: 0 }}
            onClick={() => clickView(data)}
          >
            View
          </Button>

          {(itemStatus === "pending_confirmation" ||
            itemStatus === "issue_resolved") && (
            <Button
              className="p-0 ag-success fontWeight600"
              type="link"
              style={{ position: "absolute", right: 70, bottom: 0 }}
              onClick={() => createFollowUpTicket(data)}
            >
              Create Follow-Up Ticket
            </Button>
          )}
        </Row>
      </Space>
    </Card>
  );
};

export default TicketChip;
